export default {
  Info: () => import('./info/index.vue'), // 诊所信息
  Personnel: () => import('./personnel/index.vue'), // 人员管理
  addRole: () => import('./addRole/index.vue'), // 新增角色
  Inspect: () => import('./inspect/index.vue'), // 检查治疗项设置
  RegistrationFee: () => import('./registrationFee/index.vue'), // 挂号费用设置
  templateDetail: () => import('./templateDetail/index.vue'), // 模板详情
  PerscriptionTemplate: () => import('./perscriptionTemplate/index.vue'), // 处方模板
  PerscriptionTemplateAddCn: () => import('./perscriptionTemplateAddCn/index.vue'), // 添加饮片处方
  PerscriptionTemplateAddCom: () => import('./perscriptionTemplateAddCom/index.vue'), // 添加成药处方
  PerscriptionTemplateAddSti: () => import('./perscriptionTemplateAddSti/index.vue'), // 添加敷贴处方
  PerscriptionTemplateAddInfusion: () => import('./perscriptionTemplateAddInfusion/index.vue'), // 添加输液处方
  printSet: () => import('./printSet/index.vue'), // 打印设置
  clinicSet: () => import('./clinicSet/index.vue'), // 诊所设置
};
